import type { Ref } from 'vue'
import { onMounted, onBeforeUnmount } from 'vue'

export const useClickOutside = (insideElements: Ref<Element | undefined>[], disabled: Ref<boolean>, callback: () => void) => {
  function _triggerOnClickOutside(e: any) {
    if (disabled.value) return
    const shouldClose: boolean = insideElements.every(ref => !ref.value?.contains(e.target))
    if (shouldClose) {
      callback()
    }
  }

  const _handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      callback()
    }
  }

  onMounted(async () => {
    document.addEventListener('mousedown', _triggerOnClickOutside)
    document.addEventListener('keydown', _handleKeyDown)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('mousedown', _triggerOnClickOutside)
    document.removeEventListener('keydown', _handleKeyDown)
  })
}
